import { getSupportedPaymentTypes } from '@koala/sdk/v4';
import { call, put, takeLatest, type SagaReturnType } from 'redux-saga/effects';
import actions from './actions';
import { ERROR_MESSAGES } from '@/constants/events';
import { surfaceBasketNotFound } from '@/redux/orderStatus/basketNotFound';
import { createHttpClient } from '@/services/client';
import { getOrigin } from '@/utils';
import { prepareErrorMessage } from '@/utils/global';
import * as ErrorReporter from '@/utils/errorReporter';

/**
 * Get payment
 *
 */
export function* paymentTypesGetSaga(action: ReturnType<typeof actions.paymentTypesGet>) {
  try {
    const client = createHttpClient({
      origin: getOrigin(window.location.host),
    });
    const response: SagaReturnType<typeof getSupportedPaymentTypes> = yield call(
      getSupportedPaymentTypes,
      { locationId: action.locationId, basketId: action.basketId },
      { client },
    );
    yield put(actions.paymentTypesGetSuccess(response));
  } catch (error) {
    // TEAM-15690: coo-api has lost the basket. Without this the Payment step had no payment types
    // to render and disappeared, leaving Place Order disabled with nothing on screen to say why.
    // Surfaced and reported once there, so it is not also captured below as a generic failure.
    if (
      yield* surfaceBasketNotFound(error, {
        basketId: action.basketId,
        locationId: action.locationId,
        source: 'payment_types',
      })
    ) {
      return;
    }

    const errorResponse: SagaReturnType<typeof prepareErrorMessage> = yield call(
      prepareErrorMessage,
      null,
      error,
    );
    ErrorReporter.captureException(error, 'error', {
      eventName: ERROR_MESSAGES.PAYMENT_TYPES_GET_ERROR,
      errorResponse,
    });
  }
}

export default function* rootSaga() {
  yield takeLatest(actions.PAYMENT_TYPES_GET, paymentTypesGetSaga);
}
